var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('u-btn-arrow-outlined-circle', _vm._b({
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, 'u-btn-arrow-outlined-circle', Object.assign({
    color: _vm.color
  }, _vm.$attrs), false), [_c('icon-arrow-primary', _vm._b({}, 'icon-arrow-primary', {
    direction: _vm.direction
  }, false))], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }